import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { 
  MainTitle, Subtitle,
  TextContent, HighlightText,
  JsonCodeStyle,
} from '../../../Shared';

import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import { StyledSeparated } from '../FindNearSegments/FindNearSegments.styled';

function createData(fields, type, description) {
  return { fields, type, description };
}

const listQueryParams = [
  createData('currentLat','number',"start position's latitude"),
  createData('currentLng','number',"start position's longitude"),
  createData('nextLat','number',"end position's latitude"),
  createData('nextLng','number',"end position's longitude"),
  createData('velocity','number',"velocity of traffic"),
  createData('causes','array string',"reasons of traffic status"),
  createData('weather', 'string', "weather condition at time of report")
]

const Report = props => {
  const classes = useTableStyles();

  const bodyExample = {
    "currentLat": 10.7707105,
    "currentLng": 106.656221,
    "nextLat": 10.7707105,
    "nextLng": 106.656221,
    "velocity": 2,
    "causes": ["Hello"],
    "weather": "Light rain"
  };

  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": {
      "images": [],
      "causes": ["Hello"],
      "source": "user",
      "_id": "5f8bd178fd75bf3cf2b1c6c9",
      "user": {
        "evaluation_score": 0,
        "evaluation_count": 0,
        "_id": "5dc3e711a6da9a3b2cebc1bb",
        "name": "Khanh Tran",
        "username": "khanhtran",
        "status": "active",
        "phone": "0976666666",
        "createdAt": "2019-11-07T09:42:41.861Z",
        "updatedAt": "2020-08-02T23:51:52.414Z",
        "__v": 0,
        "avatar": "link here",
        "email": "khanhtran.cse@gmail.com"
      },
      "segment": {
        "_id": 6687,
        "polyline": {
          "coordinates": [
            [106.6562176, 10.7707112],
            [106.6558895, 10.7707531]
          ],
          "_id": "5f8bd178fd75bf3cf2b1c6c4",
          "type": "LineString"
        },
        "length": 36,
        "end_node": 4537175214,
        "start_node": 4537175219,
        "street": 32580608
      },
      "velocity": 2,
      "center_point": {
        "coordinates": [106.65605355, 10.77073215],
        "_id": "5f8bd178fd75bf3cf2b1c6ca",
        "type": "Point"
      },
      "weather": "Light rain",
      "period_id": "5f8bd1582ce1ca5de1dd665d",
      "createdAt": "2020-10-18T05:24:08.251Z",
      "updatedAt": "2020-10-18T05:24:08.251Z",
      "__v": 0
    }
  }

  return (
    <div>
      <MainTitle>Report</MainTitle>
      <TextContent>Report or get report list of a specific position</TextContent>
      <Subtitle id="post-report">Post Report</Subtitle>
      <Subtitle isSmall id="request-direct">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/report/segment/here</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@POST</TextContent>
      <TextContent><b><i>Body:</i></b></TextContent>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Detail</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listQueryParams.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{row.type}</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{row.description}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TextContent>example:</TextContent>
      <JsonCodeStyle data={bodyExample} />

      <Subtitle isSmall id="response-direct">Response</Subtitle>
      <TextContent><b>Success</b></TextContent>
      <JsonCodeStyle data={responseSuccess} />
      <StyledSeparated />
    </div>
  )
}

Report.propTypes = {

}

export default Report
